import Vue from 'vue'
import Router from 'vue-router'
import Intro from '@/views/Intro'
import Timeline from '@/views/Timeline'
// import store from '@/store'

Vue.use(Router)
// const lastRoute = {
//   name: null
// }

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/timeline',
      name: 'Timeline',
      component: Timeline
      // beforeEnter: (to, from, next) => {
      //   // Bus.$emit('towerLoad')
      //   if (!store.checkShowAll === false) {
      //     const toObject = {
      //       path: '/timeline'
      //     }
      //     next(toObject)
      //   }
      //   next()
      // }
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if (to.name === lastRoute.name) {
//     const toObject = {
//       path: to.path,
//       name: to.name,
//       query: {
//         test: 'yeah'
//       },
//       params: to.params
//     }
//     lastRoute.name = to.name
//     next(toObject)
//     return
//   }
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js